import { render } from "./IconTextV2.vue?vue&type=template&id=f61a0f82&scoped=true"
import script from "./IconTextV2.vue?vue&type=script&lang=js"
export * from "./IconTextV2.vue?vue&type=script&lang=js"

import "./IconTextV2.vue?vue&type=style&index=0&id=f61a0f82&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61a0f82"]])

export default __exports__